import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { AutomationGroup } from './automation-group'

export class AutomationGroupsRepository extends BaseRepository<AutomationGroup> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.automationApiUrl + '/' + 'automations', token, cache)
    }
}
